import { atom, useAtom } from 'jotai';

export const SecurityPositionDetailsMode = {
  Total: 'TotalGainLoss',
  Today: 'TodaysGainLoss',
} as const;

export type SecurityPositionDetailsMode =
  (typeof SecurityPositionDetailsMode)[keyof typeof SecurityPositionDetailsMode];

const detailsModeAtom = atom<SecurityPositionDetailsMode>(SecurityPositionDetailsMode.Today);
export const useSecurityPositionDetailsMode = () => useAtom(detailsModeAtom);
